/**
 * @generated SignedSource<<f4259e4324fde96bf86e1bd982489551>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useCodeTestBrowserForm_Project$data = {
  readonly id: string;
  readonly status: string | null | undefined;
  readonly title: string | null | undefined;
  readonly " $fragmentType": "useCodeTestBrowserForm_Project";
};
export type useCodeTestBrowserForm_Project$key = {
  readonly " $data"?: useCodeTestBrowserForm_Project$data;
  readonly " $fragmentSpreads": FragmentRefs<"useCodeTestBrowserForm_Project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useCodeTestBrowserForm_Project",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "type": "Project",
  "abstractKey": null
};

(node as any).hash = "9cd5ae3bbeea0ce683a1ef5fa44d6a73";

export default node;
